const R = require('ramda');

const STATUS_PRIORITY = ['UNDETERMINED', 'DELETED', 'DISAPPROVED', 'PAUSED', 'IN_REVIEW', 'RUNNING'];

const TRACKER_LIST = [
  'pixel',
  'ga',
  'lead',
  'mobile',
  'google_reports',
  'naver_reports',
  'twitter_reports',
  'tiktok_reports',
  'kakao_pixel',
  'microsoft_reports',
  'linkedin_reports',
  'amazon_reports',
  'snapchat_reports',
  'criteo_reports',
  'navergfa_reports',
];

const TRACKER_LIST_FOR_FE = [
  ...TRACKER_LIST,
  'branch',
  'appsFlyer',
  'googleAnalytics',
  'googleAnalytics4',
  'googleAnalyticsMCF',
];

export const VALID_CONVERSION_PREFIX = [
  'conversions',
  'cpa',
  'conversionRate',
  'conversionValues',
  'conversionValue',
  'roas',
  'cpaWithTotalSpend',
];

const GRAPH_METRICS_BY_LEVEL = [
  [
    'conversions',
    'totalPixelConversions',
    'totalGAConversions',
    'totalOtherConversions',
    'totalGoogleAdsConversions',
    'totalNaverConversions',
    'totalTwitterConversions',
    'totalTiktokConversions',
    'totalKakaoConversions',
    'totalCriteoConversions',
    'pixelRoas',
    'gaRoas',
    'cpa',
    'conversionRate',
  ],
  ['clicks', 'engagements', 'ctr', 'cpc', 'cpm', 'impressions', 'spend', 'reach'],
  ['bounceRate', 'visitDuration'],
];

const GRAPH_METRICS = GRAPH_METRICS_BY_LEVEL.flat();

const COMMON_METRIC_COLUMNS = [
  'placements',
  'pixelRoas',
  'gaRoas',
  'totalPixelConversions',
  'totalGAConversions',
  'totalOtherConversions',
  'totalGoogleAdsConversions',
  'totalNaverConversions',
  'totalTiktokConversions',
  'totalTwitterConversions',
  'totalKakaoConversions',
  'totalCriteoConversions',
  'pixelRevenue',
  'gaRevenue',
  'clicks',
  'engagements',
  'ctr',
  'cpc',
  'cpm',
  'impressions',
  'spend',
  'reach',
  'frequency',
  'bounceRate',
  'visitDuration',
  'cpv',
  'videoViews',
  'videoViewsRate',
  'videoP25',
  'videoP50',
  'videoP75',
  'videoP100',
  'resultIndicator',
  'results',
  'cpr',
  'cvr',
];

const AD_METRICS = [
  'adId',
  'status',
  'adAccountName',
  'bidStrategy',
  'bidCap',
  'adChannelId',
  'adName',
  'campaignName',
  'adSetName',
  'placements',
  'conversionEvent',
  'targetingType',
  ...COMMON_METRIC_COLUMNS,
];

const CAMPAIGN_METRICS = [
  'status',
  'adAccountName',
  'bidStrategies',
  'bidCap',
  'campaignId',
  'conversionEvent',
  'channelSubType',
  ...COMMON_METRIC_COLUMNS,
];

const EXTRA_CAMPAIGN_METRICS = [
  'campaignId',
  'name',
  'status',
  'budget',
  'objectives',
  'subChannels',
  'adAccountName',
  'bidStrategies',
  'bidCap',
  'conversionEvents',
  'lifeTimeBudget',
  'starts',
  'ends',
  'channelSubType',
];

const PRIORITY_METRICS = [
  'roas',
  'cpa',
  'conversionRate',
  'conversions',
  'engagements',
  'visitDuration',
  'ctr',
  'cpc',
  'bounceRate',
  'clicks',
  'impressions',
  'spend',
  // 'visits',
  // 'pageViews',
];

const GOOGLE_SUBCHANNELS = [
  'google_search',
  'google_display',
  'google_universal_appstore',
  'google_universal_playstore',
  'google_video',
  'google_shopping',
  'google_performance_max',
  'google_smart',
  // 'google_unknown',
  'google_multi_channel',
  'google_discovery',
  'google_demandgen',
  'google_local',
  'google_travel',
  'google_local_services',
];
const FACEBOOK_SUBCHANNELS = ['facebook', 'instagram', 'messenger', 'audience_network'];
const YAHOO_JAPAN_SUBCHANNELS = ['yahoo_japan', 'yahooJapanDisplayAds', 'yahooJapanSearchAds'];

const CHANNEL_DETAILS = {
  google: ['gender', 'age', 'location', 'deviceTarget', 'hourOfDay'],
  facebook: [
    'subChannel',
    'gender',
    'age',
    'location',
    'deviceTarget',
    'creativeTitle',
    'creativeDescription',
    'creativeImage',
    'platformPlacement',
    'hourOfDay',
  ],
  apple: ['location', 'gender', 'age'],
  microsoft: ['gender', 'age', 'location', 'deviceTarget'],
  kakao: ['hourOfDay', 'age', 'gender', 'location'],
  yelp: [],
  naver: ['deviceTarget', 'age', 'gender'],
  tiktok: ['gender', 'age', 'location', 'platformPlacement'],
  amazon: [],
  snapchat: ['gender', 'age', 'location', 'deviceTarget'],
  yahoo: ['gender', 'age', 'location', 'deviceTarget'],
  pinterest: [],
  reddit: [],
  naverGFA: ['gender', 'age', 'location', 'deviceTarget', 'os', 'hourOfDay'],
  criteo: [],
  twitter: ['gender', 'age', 'location'],
  kakaoKeywordsAds: ['deviceTarget', 'hourOfDay', 'platformPlacement'],
};

const CHANNELS_WITH_KEYWORDS = [
  'google',
  'naver',
  'microsoft',
  'apple',
  'amazon',
  'yahoo',
  'googleAnalytics',
  'googleSpreadSheet',
  'adverity',
  'kakaoKeywordsAds',
];

const COMMON_BASIC_COLUMNS = ['level', 'adAccountName', 'subChannels'];

const EXTRA_BASIC_CAMPAIGN_COLUMNS = [
  'campaignId',
  'budget',
  'bidStrategies',
  'bidCap',
  'status',
  'objectives',
  'starts',
  'ends',
  'channelSubType',
];

const COMMON_BASIC_COLUMNS_FOR_FE = [
  'level',
  'adAccountName',
  'subChannels',
  'status',
  'campaignId',
  'budget',
  'bidStrategies',
  'bidCap',
  'objectives',
  'starts',
  'ends',
  'resultIndicator',
  'results',
  'cpr',
  'cvr',
  'channelSubType',
];

const EXTRA_CAMPAIGN_METRIC_COLUMNS = ['amountSpentPercentage'];

const EXTRA_BASIC_AD_COLUMNS = ['campaignName', 'adSetName', 'status', 'objectives', 'placements'];

const EXTRA_BASIC_AUDIENCE_COLUMNS = ['campaignName'];

const RATIO_METRICS = [
  'cpc',
  'ctr',
  'cpm',
  'cpa',
  'cpr',
  'cvr',
  'conversionRate',
  'frequency',
  'pixelRoas',
  'gaRoas',
  'roas',
  'videoViewsRate',
  'cpv',
  'amountSpentPercentage',
  'roas:googleAnalytics:purchase',
  'googleAnalytics:bounceRate',
  'googleAnalytics:averageSessionDuration',
];

const ANALYTICS_PREFIX = new Set(['ga', 'af', 'gss', 'mailchimp', 'ga4', 'branch', 'mcf']);

export const MMP_TRACKERS = ['appsFlyer'];

const DATE_GROUP_ROWS = [
  'day',
  'week',
  'weekSunSat',
  'nikeWeekNumber', // for nike
  'weekDate',
  'month',
  'autoTime',
];

export const CONVERSION_TYPES = new Set([
  'googleAnalytics',
  'googleAnalytics4',
  ...ANALYTICS_PREFIX,
  ...MMP_TRACKERS,
  ...VALID_CONVERSION_PREFIX,
]);

const CONVERT_NEEDED_TRACKERS = new Set(['googleAnalytics', 'appsFlyer', 'googleAnalytics4']);

const STATUS_TO_CHANNEL_STATUS = {
  active: ['RUNNING', 'UNKNOWN'],
  scheduled: ['SCHEDULED'],
  in_review: ['IN_REVIEW'],
  disapproved: ['DISAPPROVED'],
  deactivated: ['PAUSED', 'ENDED'],
  deleted: ['DELETED'],
};

const CHANNEL_STATUS_TO_STATUS = Object.entries(STATUS_TO_CHANNEL_STATUS).reduce((acc, [status, channelStatusList]) => {
  channelStatusList.forEach(channelStatus => (acc[channelStatus] = status));
  return acc;
}, {});

const OS_TRANSLATION = {
  playstore: 'android',
  appstore: 'ios',
  'Android (Smartphone)': 'android',
  'Android (Tablet)': 'android',
  desktop: 'desktop',
  iPad: 'ios',
  iPod: 'ios',
  iPhone: 'ios',
  other: 'other',
  unknown_os: 'unknown',
  //they want to merge this value with ios cause fb doesn't track ios 14
  'All (Automated App Ads)': 'All (Automated App Ads)',
};

const OS_TRANSLATION_REVERSE = Object.entries(OS_TRANSLATION).reduce((acc, [key, value]) => {
  if (!acc[value]) {
    acc[value] = [];
  }
  acc[value].push(key);
  return acc;
}, {});
const ALLOWED_CURRENCY = [
  'AED',
  'AFN',
  'ALL',
  'AMD',
  'ANG',
  'AOA',
  'ARS',
  'AUD',
  'AWG',
  'AZN',
  'BAM',
  'BBD',
  'BDT',
  'BGN',
  'BHD',
  'BIF',
  'BMD',
  'BND',
  'BOB',
  'BRL',
  'BSD',
  'BTC',
  'BTN',
  'BWP',
  'BYR',
  'BYN',
  'BZD',
  'CAD',
  'CDF',
  'CHF',
  'CLF',
  'CLP',
  'CNY',
  'COP',
  'CRC',
  'CUC',
  'CUP',
  'CVE',
  'CZK',
  'DJF',
  'DKK',
  'DOP',
  'DZD',
  'EGP',
  'ERN',
  'ETB',
  'EUR',
  'FJD',
  'FKP',
  'GBP',
  'GEL',
  'GGP',
  'GHS',
  'GIP',
  'GMD',
  'GNF',
  'GTQ',
  'GYD',
  'HKD',
  'HNL',
  'HRK',
  'HTG',
  'HUF',
  'IDR',
  'ILS',
  'IMP',
  'INR',
  'IQD',
  'IRR',
  'ISK',
  'JEP',
  'JMD',
  'JOD',
  'JPY',
  'KES',
  'KGS',
  'KHR',
  'KMF',
  // 'KPW', //North Korea Currency
  'KRW',
  'KWD',
  'KYD',
  'KZT',
  'LAK',
  'LBP',
  'LKR',
  'LRD',
  'LSL',
  'LTL',
  'LVL',
  'LYD',
  'MAD',
  'MDL',
  'MGA',
  'MKD',
  'MMK',
  'MNT',
  'MOP',
  'MRO',
  'MUR',
  'MVR',
  'MWK',
  'MXN',
  'MYR',
  'MZN',
  'NAD',
  'NGN',
  'NIO',
  'NOK',
  'NPR',
  'NZD',
  'OMR',
  'PAB',
  'PEN',
  'PGK',
  'PHP',
  'PKR',
  'PLN',
  'PYG',
  'QAR',
  'RON',
  'RSD',
  'RUB',
  'RWF',
  'SAR',
  'SBD',
  'SCR',
  'SDG',
  'SEK',
  'SGD',
  'SHP',
  'SLL',
  'SOS',
  'SRD',
  'STD',
  'SVC',
  'SYP',
  'SZL',
  'THB',
  'TJS',
  'TMT',
  'TND',
  'TOP',
  'TRY',
  'TTD',
  'TWD',
  'TZS',
  'UAH',
  'UGX',
  'USD',
  'UYU',
  'UZS',
  'VEF',
  'VND',
  'VUV',
  'WST',
  'XAF',
  'XAG',
  'XAU',
  'XCD',
  'XDR',
  'XOF',
  'XPF',
  'YER',
  'ZAR',
  'ZMK',
  'ZMW',
  'ZWL',
];

const AUDIENCE_ROWS = ['age', 'gender', 'location', 'deviceTarget', 'os'];

const DYNAMIC_CREATIVE_ROWS = ['creativeTitle', 'creativeDescription', 'creativeImage', 'platformPlacement'];

const BASIC_ROW_LIST = [
  'channel',
  'adAccount',
  'campaign',
  'adSet',
  'ad',
  'objectives',
  'status',
  'keyword',
  'subChannel',
  // 'placement',
  ...DATE_GROUP_ROWS,
  ...AUDIENCE_ROWS,
  ...DYNAMIC_CREATIVE_ROWS,
];

const CREATIVE_INSIGHT_FILED_BY_BREAKDOWN = {
  creativeWord: 'words',
  colorClustering: 'colorHSL',
  emojiAnalysis: 'emojis',
  imageHash: 'imageHash',
};

module.exports = {
  STATUS_PRIORITY,
  TRACKER_LIST,
  CAMPAIGN_METRICS,
  EXTRA_CAMPAIGN_METRICS,
  AD_METRICS,
  GRAPH_METRICS_BY_LEVEL,
  GRAPH_METRICS,
  PRIORITY_METRICS,
  GOOGLE_SUBCHANNELS,
  FACEBOOK_SUBCHANNELS,
  AUDIENCE_METRICS: [],
  EXTRA_AUDIENCE_METRICS: [],
  CHANNEL_DETAILS,
  COMMON_BASIC_COLUMNS,
  COMMON_METRIC_COLUMNS,
  EXTRA_BASIC_CAMPAIGN_COLUMNS,
  EXTRA_CAMPAIGN_METRIC_COLUMNS,
  EXTRA_BASIC_AD_COLUMNS,
  EXTRA_BASIC_AUDIENCE_COLUMNS,
  CHANNELS_WITH_KEYWORDS,
  RATIO_METRICS,
  CONVERSION_TYPES,
  STATUS_TO_CHANNEL_STATUS,
  CHANNEL_STATUS_TO_STATUS,
  OS_TRANSLATION,
  OS_TRANSLATION_REVERSE,
  TRACKER_LIST_FOR_FE,
  COMMON_BASIC_COLUMNS_FOR_FE,
  VALID_CONVERSION_PREFIX,
  ALLOWED_CURRENCY,
  DATE_GROUP_ROWS,
  AUDIENCE_ROWS,
  DYNAMIC_CREATIVE_ROWS,
  BASIC_ROW_LIST,
  CONVERT_NEEDED_TRACKERS,
  ANALYTICS_PREFIX,
  CREATIVE_INSIGHT_FILED_BY_BREAKDOWN,
  YAHOO_JAPAN_SUBCHANNELS,
};
